export const FIELDS = {
  ID: 'id',
  TASK_TYPE_ID: 'taskTypeId',
  TASK_TYPE_NAME: 'taskTypeName',
  TASK_STATUS_ID: 'taskStatusId',
  TASK_STATUS_NAME: 'taskStatusName',
  TASK_PRIORITY_ID: 'taskPriorityId',
  TASK_PRIORITY_NAME: 'taskPriorityName',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  ACCOUNT_TYPE: 'accountType',
  MAIN_PHONE: 'mainPhone',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  ADDRESS3: 'address3',
  CITY: 'city',
  STATE: 'state',
  ZIP_CODE: 'zipCode',
  COUNTRY_CODE: 'countryCode',
  COUNTRY: 'country',
  CONTACT_ID: 'contactId',
  FULL_ADDRESS: 'fullAddress',
  CONTACT_FIRST_NAME: 'contactFirstName',
  CONTACT_LAST_NAME: 'contactLastName',
  CONTACT_EMAIL: 'contactEmail',
  DIRECT_PHONE: 'directPhone',
  CELL_PHONE: 'cellPhone',
  ASSIGNED_TO_USER_ID: 'assignedToUserId',
  ASSIGNED_TO_USER_FULL_NAME: 'assignedToUserFullName',
  TASK_DUE: 'taskDue',
  AGING: 'aging',
  SUBJECT: 'subject',
  DESCRIPTION: 'description',
  NOTES: 'notes',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',};